
import { useTranslation } from "react-i18next";
import i18next from "i18next";
export default function ProjectDetailTab(prop) {
  const data = prop.data;
  const { t } = useTranslation();

  return (
    <>
      <div className="listing-content">
        <div className="project-information">
          <h6>{t("finance.project_information")}</h6>
          <div className="translation-summary">
            <div className="project-table">
              <ul>
                <li className="finance-columns">
                  <div className="title">{t("finance.project_name")}</div>
                  <div className="text">{data?.projectName}</div>
                </li>
                <li className="finance-columns">
                  <div className="title">{t("finance.project_status")}</div>
                  <div className="text">{data?.projectStatus}</div>
                </li>
              </ul>
              <ul>
                <li className="finance-columns">
                  <div className="title">{t("finance.project_id_pid")}</div>
                  <div className="text">{data?.projectId}</div>
                </li>
                <li className="finance-columns">
                  <div className="title">{t("finance.source_language")}</div>
                  <div className="text">{data?.sourceLanguage}</div>
                </li>
              </ul>
              <ul>
                <li className="finance-columns">
                  <div className="title">{t("finance.account")}</div>
                  <div className="text">{data?.accountName}</div>
                </li>
                <li className="finance-columns">
                  <div className="title">{t("finance.target_languages")}</div>
                  <div className="text">{data?.targetLanguages}</div>
                </li>
              </ul>
              <ul>
                <li className="finance-columns">
                  <div className="title">{t("finance.project_owner")}</div>
                  <div className="text">{data?.ownerName}</div>
                </li>
                <li className="finance-columns">
                  <div className="title">{t("finance.po_number")}</div>
                  <div className="text">{data?.poNumber}</div>
                </li>
              </ul>
              <ul>
                <li className="finance-columns">
                  <div className="title">{t("finance.service_provider")}</div>
                  <div className="text">{data?.serviceProvider}</div>
                </li>
                <li className="finance-columns">
                  <div className="title">{t("finance.department")}</div>
                  <div className="text">{data?.department}</div>
                </li>
              </ul>
              <ul>
                <li className="finance-columns last-row">
                  <div className="title">{t("finance.content_source")}</div>
                  <div className="text">{data?.projectContentType}</div>
                </li>
                <li className="finance-columns last-row">
                  <div className="title">{t("finance.automated_vendor_project")}</div>
                  {data?.automated ? (
                    <input type="checkbox" disabled="disabled" checked />
                  ) : (
                    <input type="checkbox" disabled="disabled" />
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
